import React from 'react';
import { AlertCircle, Lock, LogOut, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function SubscriptionBlocked({ dados }) {
  const navigate = useNavigate();
  const status = dados?.status || 'BLOQUEADA';

  // Configuração do WhatsApp do Seu Suporte (SaaS)
  const WHATSAPP_SUPORTE = "5511999999999"; // <--- COLOQUE SEU NÚMERO AQUI
  const mensagemSuporte = encodeURIComponent(`Olá, sou da agência e minha conta está com status: ${status}. Gostaria de regularizar.`);

  // Lógica de Mensagens Personalizadas
  const getContent = () => {
    switch (status) {
      case 'BLOQUEADA':
        return {
          titulo: "Acesso Temporariamente Bloqueado",
          msg: "Sua conta foi bloqueada administrativamente. Entre em contato com nossa equipe de suporte para entender o motivo e regularizar seu acesso.",
          icon: <Lock className="w-16 h-16 text-red-500 mb-4" />
        };
      case 'CANCELADA':
        return {
          titulo: "Assinatura Cancelada",
          msg: "Sua assinatura foi cancelada. Seus dados estão salvos, mas você precisa reativar seu plano para acessar o sistema novamente.",
          icon: <AlertCircle className="w-16 h-16 text-gray-500 mb-4" />
        };
      case 'INADIMPLENTE':
      default:
        return {
          titulo: "Pendência Financeira Identificada",
          msg: "Identificamos uma pendência no pagamento da sua última fatura. O acesso foi suspenso temporariamente até a regularização.",
          icon: <AlertCircle className="w-16 h-16 text-orange-500 mb-4" />
        };
    }
  };

  const content = getContent();

  const handleLogout = () => {
    // Limpa os dados e manda para o login
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="flex flex-col items-center text-center p-8 md:p-12">
      
      {/* Ícone Animado */}
      <div className="animate-bounce">
        {content.icon}
      </div>

      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        {content.titulo}
      </h1>

      <p className="text-lg text-gray-600 max-w-lg mb-8 leading-relaxed">
        {content.msg}
      </p>

      {/* Ações */}
      <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md justify-center">
        
        {/* Botão Falar com Suporte (WhatsApp) */}
        <Button 
          className="w-full sm:w-auto bg-green-600 hover:bg-green-700 text-white gap-2 py-6 text-lg"
          onClick={() => window.open(`https://wa.me/${WHATSAPP_SUPORTE}?text=${mensagemSuporte}`, '_blank')}
        >
          <MessageCircle className="w-5 h-5" />
          Falar com Suporte
        </Button>

        {/* Botão Sair (Essencial pois o menu está travado) */}
        <Button 
          variant="outline" 
          className="w-full sm:w-auto border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700 gap-2 py-6 text-lg"
          onClick={handleLogout}
        >
          <LogOut className="w-5 h-5" />
          Sair do Sistema
        </Button>

      </div>
      
      <p className="mt-8 text-xs text-gray-400">
        ID da Agência: {dados?.agencia_id || 'N/A'}
      </p>
    </div>
  );
}